import { useCallback, useEffect, useState } from 'react'
import inViewport from 'in-viewport'

export const useAppearedInView = ref => {
  const [inView, setInView] = useState(false)

  const handleScroll = useCallback(() => {
    if (!inView) {
      const inViewportVal = inViewport(ref?.current)
      setInView(inViewportVal)
    }
  }, [ref, inView, setInView])

  useEffect(() => {
    if (inView || !ref.current) return
    const inViewportVal = inViewport(ref.current)
    setInView(inViewportVal)

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [handleScroll, inView, ref])

  return inView
}
